import { useEffect, useRef, useState } from 'react';
import { fieldType } from 'src/types/form';
import { TGDisclosure } from '../../TGDisclosure';
import { SubResetFilter } from 'src/pages/DashboardPage/mytasks/meetingsPage/components/MeetingCard';
import { FlexCol } from 'src/utils/flexLayouts';
import { formatNumberToTime } from 'src/constants';

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    value: any;
    errors?: any;
    type: string;
};

function TimeRange(props: Props) {
    const { dataField, onChange, value, errors, type } = props;
    const inputRefFrom = useRef<HTMLInputElement>(null);
    const inputRefBefore = useRef<HTMLInputElement>(null);
    const [timeFrom, setTimeFrom] = useState("");
    const [timeBefore, setTimeBefore] = useState("");
    const [errorTime, setErrorTime] = useState("");

    useEffect(() => {
        if (dataField.default) {
            setTimeFrom(dataField.default.fromTime) //Нужно передавать строкой через :
            setTimeBefore(dataField.default.beforeTime) //Нужно передавать строкой через :
        }
    }, [dataField]);

    useEffect(() => {
        if (!value) {
            setTimeFrom('');
            setTimeBefore('');
        } else {
            setTimeFrom(formatNumberToTime(value.fromTime));
            setTimeBefore(formatNumberToTime(value.beforeTime));
        }
    }, [value])

    const formatTime = (time: string) => {
        return time.length === 5 ? time : time.padStart(5, '0');
    };

    const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
        const newTime = formatTime(event.target.value);
        if (type === 'from') {
            setTimeFrom(newTime);
        } else {
            setTimeBefore(newTime);
        }
    };

    useEffect(() => {
        if (timeBefore && timeFrom) {
            if (Number(timeBefore.replace(":", "")) > Number(timeFrom.replace(":", ""))) {
                setErrorTime("");
                onChange({ fromTime: Number(timeFrom.replace(":", "")), beforeTime: Number(timeBefore.replace(":", "")) })
            } else {
                setErrorTime("Проверьте корректность времени. Время до, должно быть меньше времени после");
            }
        } else {
            setErrorTime("Обязательно заполнение всех данных по времени");
        }
    }, [timeBefore, timeFrom]);

    const handleContainerClickFrom = () => {
        if (inputRefFrom.current) {
            inputRefFrom.current.showPicker();
        }
    };

    const handleContainerClickBefore = () => {
        if (inputRefBefore.current) {
            inputRefBefore.current.showPicker();
        }
    };

    return (

        <TGDisclosure disabled={dataField.disabled} wrapperClassName={dataField.width} title={dataField.title} count={value && 1 || 0}>
            <div className={`${dataField.width} mb-5`}>
                {/* <label className='flex flex-row justify-between text-sm font-medium leading-6 text-gray-900'>
                    <span>{dataField.title}</span>
                    {dataField.require && (
                        <div className='flex flex-row justify-between'>
                            {Object.keys(errors).length > 0 && errors[dataField.key] && <span className='text-[#BA0C2F]'>Заполните поле&nbsp;</span>}
                            <span className='text-[#BA0C2F]'>*</span>
                        </div>
                    )}
                </label> */}
                <FlexCol className='mt-2 relative cursor-pointer gap-2' onClick={handleContainerClickFrom}>
                    <span>Время от</span>
                    <input
                        ref={inputRefFrom}
                        type='time'
                        className='text-left block w-full text-base rounded-lg border border-[#DFE4EA] py-3 px-5 text-black outline-none disabled:text-[#6B7280] disabled:bg-[#E5E7EB] cursor-pointer'
                        value={timeFrom}
                        onChange={(e) => handleTimeChange(e, 'from')}
                        disabled={dataField.disabled}
                        placeholder={dataField.placeholder}
                    />
                </FlexCol>
                <FlexCol className='mt-2 relative cursor-pointer gap-2' onClick={handleContainerClickBefore}>
                    <span>Время до</span>
                    <input
                        ref={inputRefBefore}
                        type='time'
                        className='text-left block w-full text-base rounded-lg border border-[#DFE4EA] py-3 px-5 text-black outline-none disabled:text-[#6B7280] disabled:bg-[#E5E7EB] cursor-pointer'
                        value={timeBefore}
                        onChange={(e) => handleTimeChange(e, 'before')}
                        disabled={dataField.disabled}
                        placeholder={dataField.placeholder}
                    />
                </FlexCol>
                <FlexCol className='mt-2'>{errorTime}</FlexCol>
            </div>
            <SubResetFilter resetFilter={() => {
                setTimeFrom('');
                setTimeBefore('');
                onChange(null);
            }} />
        </TGDisclosure>

    );
}

export default TimeRange;
